import React from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { defaultAllSelection } from "services/constants/selections";
import { ReportNamesList, isAllCompanies } from "../ReportNamesList";
import { PfStatutoryReports } from "./PF";
import { EsiStatutoryReports } from "./ESI";
import { LwfStatutoryReports } from "./LWF";
import { PtStatutoryReports } from "./PT";

// Payroll > Reports > Statutory Reports: opens on the same "Report Names"
// list as Payroll Reports (PF, ESI, PT, LWF). Picking a report opens it;
// its back arrow returns to the list. The report and tab are in the
// address (?item=esi&tab=validation) so other screens can link straight
// to them.

const REPORTS = [
  { value: "pf", label: "Provident Fund (PF)" },
  { value: "esi", label: "Employees' State Insurance (ESI)" },
  { value: "pt", label: "Professional Tax (PT)" },
  { value: "lwf", label: "Labour Welfare Fund (LWF)" },
];

export const StatutoryReports = () => {
  const history = useHistory();
  const { search } = useLocation();
  const { companyId, companyName } = useSelector((state) => state.tokenReducer);
  const params = new URLSearchParams(search);
  const item = REPORTS.find((report) => report.value === params.get("item"))?.value;
  const tab = params.get("tab") || undefined;
  const backToList = () => history.push({ search: "" });

  if (item === "pt") return <PtStatutoryReports key={`pt:${tab}`} onBack={backToList} initialTab={tab} />;
  if (item === "lwf") return <LwfStatutoryReports key={`lwf:${tab}`} onBack={backToList} initialTab={tab} />;
  if (item === "esi") return <EsiStatutoryReports key={`esi:${tab}`} onBack={backToList} initialTab={tab} />;
  if (item === "pf") return <PfStatutoryReports key="pf" onBack={backToList} />;
  return (
    <ReportNamesList
      reports={REPORTS}
      onOpen={(report) => {
        if (isAllCompanies(companyId, companyName, defaultAllSelection)) {
          window.alert("Please select specific company");
          return;
        }
        history.push({ search: `?item=${report.value}` });
      }}
    />
  );
};
